<template>
  <div>
    <div class="row form-group">
      <label class="col-md-4 col-form-label">
        {{ $t('school.payment.setup.feeSetup.paymentTerm') }}
        <span class="validate">*</span>
        <i class="fa fa-spinner spin" v-if="payment_term_fetch"></i>
      </label>
      <div class="col-md-8">
        <select
          v-model="model.payment_term_id"
          class="form-control"
          :class="{
            'is-invalid': errors.has('payment_term_id')
          }"
        >
          <option value>{{ $t('select') }}</option>
          <option
            v-for="(p, index) in paymentTerm"
            :key="index"
            :value="p.payment_term_id"
            >{{ p.payment_term }}</option
          >
        </select>
        <div class="invalid-feedback" v-if="errors.has('payment_term_id')">
          {{ errors.first('payment_term_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <label class="col-md-4 col-form-label">
        {{ $t('school.payment.setup.feeSetup.distance') }}
        <span class="validate">*</span>
        <i class="fa fa-spinner spin" v-if="distance_fetch"></i>
      </label>
      <div class="col-md-8">
        <select
          v-model="model.distance_id"
          class="form-control"
          :class="{
            'is-invalid': errors.has('distance_id')
          }"
        >
          <option value>{{ $t('select') }}</option>
          <option
            v-for="(d, index) in distances"
            :key="index"
            :value="d.distance_id"
            >{{ d.distance_description }}</option
          >
        </select>
        <div class="invalid-feedback" v-if="errors.has('distance_id')">
          {{ errors.first('distance_id') }}
        </div>
      </div>
    </div>
    <div class="row form-group">
      <label class="col-md-4 col-form-label">
        {{ $t('school.payment.setup.feeSetup.transaction') }}
        <span class="validate">*</span>
        <i class="fa fa-spinner spin" v-if="transaction_fetch"></i>
      </label>
      <div class="col-md-8">
        <select
          v-model="model.way_id"
          class="form-control"
          :class="{
            'is-invalid': errors.has('way_id')
          }"
        >
          <option value>{{ $t('select') }}</option>
          <option
            v-for="(t, index) in transactions"
            :key="index"
            :value="t.way_id"
            >{{ t.way_description }}</option
          >
        </select>
        <div class="invalid-feedback" v-if="errors.has('way_id')">
          {{ errors.first('way_id') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'transportation',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
      payment_term_fetch: true,
      distance_fetch: true,
      transaction_fetch: true,
      errors: new Errors()
    }
  },
  created() {
    ;(this.model = this.value),
      this.getPaymentTerm().finally(() => {
        this.payment_term_fetch = false
      })
    this.getDistance().finally(() => {
      this.distance_fetch = false
    })
    this.getTransaction().finally(() => {
      this.transaction_fetch = false
    })
  },
  computed: {
    ...mapState('feeSetup', ['paymentTerm', 'distances', 'transactions'])
  },
  methods: {
    ...mapActions('feeSetup', [
      'getPaymentTerm',
      'getDistance',
      'getTransaction'
    ])
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    }
  }
}
</script>
